import { useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import sandboxAtom from '../Sandbox/sandbox.atom'
import { useMemo, useState } from 'react'
import LightLayout from '../../shared/Layouts/LightLayout'
import { rocketImages } from '../Navigation/components/RocketsNavigation'
import css from './rocket.module.css'
import NumberInput from '../../shared/Inputs/NumberInput'
import TextField from '../../shared/Forms/TextField'
import LevelDropdown from '../Navigation/components/LevelNavigation/components/LevelDropdown'
import Button from '../../shared/Buttons/Button'
import BackButton from '../../shared/Buttons/BackButton'
import useHttpLoader from '../../hooks/useHttpLoader'
import setsService from '../../services/sets.service'
import arrayUtils from '../../utils/array.utils'
import CreateLevelModal from '../Navigation/components/LevelNavigation/components/CreateLevelModal'
import EditLevelModal from '../Navigation/components/LevelNavigation/components/EditLevelModal'

const RocketScreen = () => {
  const { wait, loading } = useHttpLoader()
  const params = useParams()
  const id = params.id
  const [sandboxState, setSandboxState] = useRecoilState(sandboxAtom)
  const [createLevelModalOpen, setCreateLevelModalOpen] = useState(false)
  const [updateLevelModalOpen, setUpdateLevelModalOpen] = useState(false)

  const set = useMemo(() => {
    return sandboxState.sets.find((s) => s.id === id)
  }, [id, sandboxState.sets])

  const [draftSet, setDraftSet] = useState(set)

  const handleSave = () => {
    wait(setsService.update(set.id, draftSet), (resp) => {
      if (resp.status === 'success') {
        setSandboxState((prev) => ({ ...prev, sets: arrayUtils.updateItem({ items: prev.sets }, resp.body).items }))
      }
    })
  }

  const handleChange = (val: any, name: string) => {
    setDraftSet((prev) => ({ ...prev, [name]: val }))
  }

  const setIndex = useMemo(() => {
    return sandboxState.sets.findIndex((s) => s.id === id)
  }, [sandboxState.sets, id])

  return (
    <LightLayout>
      {createLevelModalOpen && <CreateLevelModal onClose={() => setCreateLevelModalOpen(false)} />}
      {updateLevelModalOpen && (
        <EditLevelModal onClose={() => setUpdateLevelModalOpen(false)} levelId={draftSet.level} />
      )}
      <div className="flex-form" style={{ alignItems: 'center' }}>
        <div
          className={css.rocketImage}
          style={{ backgroundImage: `url("${rocketImages[setIndex % rocketImages.length]}")` }}
        />
        <div className={css.form}>
          <div className={css.backIcon}>
            <BackButton />
          </div>
          <TextField header="Ordering index">
            <NumberInput value={draftSet.orderingIndex} onChange={handleChange} name="orderingIndex" />
          </TextField>
          <div className="inline-flex-gap">
            <TextField header="Уровень" wrapperStyle={{ width: 'fit-content' }}>
              <LevelDropdown level={draftSet.level} onChange={handleChange} name="level" />
            </TextField>
            <span
              style={{ flexShrink: 0, fontSize: 20, cursor: 'pointer', marginTop: '20px', marginLeft: '10px' }}
              onClick={() => setCreateLevelModalOpen(true)}
            >
              + Создать уровень
            </span>
          </div>

          <div className="inline-flex-gap" style={{ marginTop: '2em' }}>
            <Button loading={loading} onClick={handleSave}>
              Сохранить
            </Button>
            {draftSet.level && <Button onClick={() => setUpdateLevelModalOpen(true)}>Редактировать уровень</Button>}
          </div>
        </div>
      </div>
    </LightLayout>
  )
}

export default RocketScreen
